<template>
    <div class="merchant">
        <template v-if="flag">
            <tiktokWithdrawal :id="merchantId" v-on="$listeners"></tiktokWithdrawal>
        </template>
        <template v-else>
            <div class="title">
                <span>选择抖音商户</span>
                <el-button type="primary" @click="gooldWithdrawal" size="medium">进入旧版提现</el-button>
            </div>
            <el-radio-group v-model="merchantId">
                <el-radio-button :label="item.id" v-for="(item, index) in chantList" :key="index">抖音商户{{index ? index: ''}}</el-radio-button>
            </el-radio-group>
        </template>
    </div>
</template>
<script>
import { mapActions } from 'vuex'
import tiktokWithdrawal from './tiktokWithdrawal.vue'
export default {
    data() {
        return {
            chantList: [],
            merchantId: '',
            flag: false
        }
    },
    components: {
        tiktokWithdrawal
    },
    methods: {
        ...mapActions('dataCenter', ['merchantList']),
        async getMerchantList() {
            let res = await this.merchantList({ status: 1 })
            this.chantList = res
            if(res.length == 1) {
                this.merchantId = res[0].id
            }
        },
        gooldWithdrawal() {
            this.$emit('change', 2)
        }
    },
    created() {
        this.getMerchantList()
    },
    watch: {
        merchantId(news) {
            if(news) {
                this.flag = true
            }
        }
    }
}
</script>
<style lang="less" scoped>
    .merchant {
        width: 100%;
        height: 100%;
    }
    .title {
        display: flex;
        justify-content: space-between;
        margin-bottom: 16px;
    }
</style>